(function ($) {
  $(document).ready(function () {
    // $(document).foundation();
    // console.log("app ready!!");

    const mainNav = document.querySelector('.main-nav');
    const scrollThreshold = 10; // Pixels to scroll before switching classes

    const handleScroll = () => {
        const st = window.scrollY;

        if (st > scrollThreshold) {
            // We have scrolled down - apply the sticky/transformed state
            mainNav.classList.add('lower-down');
        } else {
            // We are back at the very top
            mainNav.classList.remove('lower-down');
        }
    };

    // Listen for scroll events
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Run once on load in case the page starts scrolled down
    handleScroll();

   //  let didScroll;
   //  let lastScrollTop = 0;
   //  const delta = 5;
   //  const navbarHeight = document.querySelector('.main-nav').offsetHeight;
   //  window.addEventListener('scroll', () => {
   //      didScroll = true;
   //  });

   //  setInterval(() => {
   //      if (didScroll) {
   //          hasScrolled();
   //          didScroll = false;
   //      }
   //  }, 250);

   // function hasScrolled() {
   //      const st = window.scrollY;
        
   //      // Ensure they scroll more than delta
   //      if (Math.abs(lastScrollTop - st) <= delta) return;

   //      const mainNav = document.querySelector('.main-nav');
   //      if (st > lastScrollTop && st > navbarHeight) {
   //          // Scroll Down
   //          mainNav.classList.remove('nav-down', 'lower-down');
   //          mainNav.classList.add('nav-up');
   //      } else {
   //          // Scroll Up
   //          if (st + window.innerHeight < document.documentElement.scrollHeight) {
   //              if (st > navbarHeight) {
   //                  mainNav.classList.add('lower-down');
   //              } else {
   //                  mainNav.classList.remove('lower-down');
   //              }
   //              mainNav.classList.remove('nav-up');
   //              mainNav.classList.add('nav-down');
   //          }
   //      }
   //      lastScrollTop = st;
        
   //      if (window.scrollY < 10) {
   //          mainNav.classList.remove('lower-down');
   //      }
   //  }


    // Check for nav-down class and browser width -> add padding to body to compensate
    // const mainNav = document.querySelector('.main-nav');
    // if (mainNav.classList.contains('nav-down') && window.innerWidth >= 768) {
    //     document.body.classList.add('has-fixed-nav');
    // }

    $('#navToggle').on('click', function(){
      
      var toggle = $(this);

      toggle.toggleClass('is-active');
      toggle.siblings('#primary-menu').toggleClass('is-active');
      // toggle.parent('.menu-container').toggleClass('is-active');
      $('body').toggleClass('is-open');
      $('#primary-menu .menu-item-has-children').removeClass('is-mobile-open');
    });

    $('.nav-search-icon').on('click', function(){
      var toggle = $(this);

      toggle.toggleClass('is-active');
      toggle.closest('.nav-wrapper').toggleClass('search-active');
    });

    $('#overlayToggle').on('click', function(){
      $('body').addClass('is-fixed');
      $('#overlayMenu').addClass('is-active');
    });

    function removeActive() {
      $('#overlayMenu').removeClass('is-active is-closing');
      $('body').removeClass('is-fixed');
    }

    $('#overlayClose').on('click', function(){
      // $('body').removeClass('is-fixed');
      $('#overlayMenu').addClass('is-closing');
      setTimeout( removeActive, 250 );
      // $('#overlayMenu').removeClass('is-active');
    });

    $('.remove-link').each( function(){
      $(this).find('> a').on('click', function(e){
        e.preventDefault();
      });
    });

    var $propsource = $('#nav-property-source').html();
    // console.log($propsource);
    $('.nav-property-receiver').html($propsource);

    if ($('.prop-accordion').length) {
      $('.prop-accordion .tab-content h4').on('click', function() {
          var $currentTab = $(this).parent('.tab-content');
          
          // Close all sibling tabs
          $currentTab.siblings('.tab-content').removeClass('is-active');

          // Toggle the clicked tab
          $currentTab.toggleClass('is-active');
      });
    }
    // $('#scroll-down').on( 'click', function(e){
    //   e.preventDefault();
    // });
    // var $scrolldown = $('#scroll-down').attr('href');
    // console.log($scrolldown);
    // var $scroller = $scrolldown.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
    // $('#main .entry-content > *').eq(1).attr('id', $scroller);


    $(window).scroll(function() {
      $('.in-view').each(function(){
        var imagePos = $(this).offset().top;
        var topOfWindow = $(window).scrollTop();
  
        if (imagePos < topOfWindow+800) {
          $(this).addClass("fadeInUp");
        }
      });

      $('.in-view-fade').each(function(){
        var imagePos = $(this).offset().top;
        var topOfWindow = $(window).scrollTop();

        if (imagePos < topOfWindow+800) {
          $(this).addClass("fadeIn");
        }
      });

      $('.in-view-zoom').each(function(){
        var imagePos = $(this).offset().top;
        var topOfWindow = $(window).scrollTop();
  
        if (imagePos < topOfWindow+800) {
          $(this).addClass("zoomIn");
        }
      });
    });

    if( $('body.single-rentpress_floorplan').length) {
      $('#app h3').each(function() {
          if ($(this).text().includes('Community')) {
              $(this).text($(this).text().replace(/\bCommunity\b/g, 'Neighborhood'));
          }
      });
    }

    if ($('.property-testimonial-slider').length) {
      $('.property-testimonial-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 400,
        slidesToShow: 1,
        appendArrows: $('#propertyTestimonialArrows'),
        responsive: [
          {
            breakpoint: 600,
            settings: {
              appendArrows: $('.property-testimonial-slider'),
            }
          }
        ]
      });
    }

    if( $('.rentpress-property-hours-shortcode-wrapper').length) {
      $('.rentpress-property-hours-shortcode-wrapper ul li').each(function() {
          // Replace ':00 ' with ' ' (space) and ':00-' with '-' (removing the :00 from the time)
          $(this).text($(this).text().replace(/:00\s/g, ' ').replace(/:00-/g, '-'));
      });
    }
    if( $('.rentpress-office-hours-list').length) {
      $('.rentpress-office-hours-list li').each(function() {
          // Replace ':00 ' with ' ' (space) and ':00-' with '-' (removing the :00 from the time)
          $(this).text($(this).text().replace(/:00\s/g, ' ').replace(/:00-/g, '-'));
      });
    }

  }); //on ready
})(jQuery);

// document.addEventListener('DOMContentLoaded', function() {
//     if (window.innerWidth > 840) {
//         // Find the element to detach
//         var controls = document.querySelector('.splide__arrows');

//         if (controls) {
//             // Detach the element (remove it from its current parent)
//             controls.parentNode.removeChild(controls);

//             // Append the detached element to the new parent
//             var newParent = document.getElementById('testimonial-slider-controls');

//             if (newParent) {
//                 newParent.appendChild(controls);
//             } else {
//                 console.error('Element with ID "testimonial-slider-controls" does not exist.');
//             }
//         } else {
//             console.error('Element with class "splide__arrows" does not exist.');
//         }
//     }
// });
